import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../context/ThemeContext";
import UserContext from "../../../../context/UserContext";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12($firmCode: String!, $rClassCode: String!, $firmMainCode: String!) {
    tbl_htl_room_class_coop(
      where: {
        firm_main_code_n: { _eq: $firmMainCode},
        firm_sub_code_n: { _eq: $firmCode },
        r_class_code_n: { _eq: $rClassCode }
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_sub_code_n
      r_class_code_n
      r_class_name_n
      int_ID
    }
  }
`;


const GET_RCLASS = gql`
  query MyQuery($drctype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drctype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;


const UPDATE_FIRM = gql`
mutation UpdateRoomClass(
  $firmCode: String!
  $rClassCode: String!
  $rClassName: String!
) {
  update_tbl_htl_room_class_coop(
    where: {
      firm_sub_code_n: { _eq: $firmCode },
      r_class_code_n: { _eq: $rClassCode }
    },
    _set: { r_class_name_n: $rClassName, r_class_code_n: $rClassCode }
  ) {
    affected_rows
  }
}
`;

const INSERT_RCLASS = gql`
  mutation InsertRoomClass(
    $firmCode: String!
    $firmMainCode: String!
    $rClassName: String!
    $rClassCode: String!
    $ownFirmCode: String!
    $ownFirmSubCode: String!
    $ownFirmSubType: String!
    
  ) {
    insert_tbl_htl_room_class_coop(
      objects: {
        firm_sub_code_n: $firmCode,
        firm_main_code_n: $firmMainCode,
        own_firm_main_code: $ownFirmCode,
        own_firm_sub_code: $ownFirmSubCode,
        own_firm_sub_type: $ownFirmSubType,
        r_class_code_n: $rClassCode,
        r_class_name_n: $rClassName,
        
        
      }
    ) {
      affected_rows
    }
  }
`;









const FirmSubUpdate = () => {


  const { theme, setTheme } = useContext(ThemeContext);
  const { varCode, setVarCode } = useContext(ThemeContext);
  const { varCode2, setVarCode2 } = useContext(ThemeContext);
  const { users } = useContext(UserContext);
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmCode: theme, firmMainCode: varCode2, rClassCode: varCode },
  });
  const [UpdateRoomClass] = useMutation(UPDATE_FIRM);
  const [InsertRoomClass] = useMutation(INSERT_RCLASS);

  const firmData = data && data.tbl_htl_room_class_coop ? data.tbl_htl_room_class_coop[0] : null;

  const { loading: drcLoading, error: drcError, data: drcData } = useQuery(GET_RCLASS, {
    variables: { drctype: "RCLS", lang: "en" },
  });

  const roomClassSelectItems = drcData && drcData.tbl_gnl_def
  ? drcData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  
  const [rClassName, setRClassName] = useState(firmData ? firmData.r_class_name_n : "");
  const [rClassCode, setRClassCode] = useState(firmData ? firmData.r_class_name_n : "");
  
  const [firmType, setFirmType] = useState(firmData ? firmData.firm_type : "");  
  const [place, setPlace] = useState(firmData ? firmData.place : "");
  console.log("Firm Data:", firmData);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;


  const lang = users.userLang;
  const intl = useIntl();
  const currentLocale = "ru"; 
  const close_form = messages[currentLocale].close_form;
  const new_firm = messages[currentLocale].new_firm;
  const search_by_firm_name = messages[currentLocale].search_by_firm_name;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const typerec = messages[currentLocale].typerec;
  const placerec = messages[currentLocale].placerec;
  const time_zone = messages[currentLocale].time_zone;
  const updaterec = messages[currentLocale].updaterec;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;
  const create_room_classrec = messages[currentLocale].create_room_classrec;
  const create_room_typerec = messages[currentLocale].create_room_typerec;
  const select_a_room_class = messages[currentLocale].select_a_room_class
  const create = messages[currentLocale].create;
  const update = messages[currentLocale].update;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const definitions = messages[currentLocale].definitions;
  const managing_hotel = messages[currentLocale].managing_hotel;
  const firm_detail = messages[currentLocale].firm_detail;
  const agency_detail = messages[currentLocale].agency_detail;
  const sub_agency_detail = messages[currentLocale].sub_agency_detail;
  const sub_hotel_detail = messages[currentLocale].sub_hotel_detail;
  const main_department_tab = messages[currentLocale].main_department_tab;
  const sub_department_tab = messages[currentLocale].sub_department_tab;
  const rulesrec = messages[currentLocale].rulesrec;
  const account_cart_tab = messages[currentLocale].account_cart_tab;
  const bank_accounts_tab = messages[currentLocale].bank_accounts_tab;
  const room_class_tab = messages[currentLocale].room_class_tab;
  const room_type_tab = messages[currentLocale].room_type_tab;
  const room_class_code = messages[currentLocale].room_class_code;
  const room_class_name = messages[currentLocale].room_class_name;
  const room_type_code = messages[currentLocale].room_type_code;
  const room_type_name = messages[currentLocale].room_type_name;
  const room_bed_title = messages[currentLocale].room_bed_title;
  const room_bed_type_title = messages[currentLocale].room_bed_type_title;
  const room_total_title = messages[currentLocale].room_total_title;
  const room_max_pax_title = messages[currentLocale].room_max_pax_title;
  const room_min_pax_title = messages[currentLocale].room_min_pax_title;
  const room_chl_max_title = messages[currentLocale].room_chl_max_title;
  const room_chl_min_title = messages[currentLocale].room_chl_min_title;
  const room_baby_start_title = messages[currentLocale].room_baby_start_title;
  const room_baby_end_title = messages[currentLocale].room_baby_end_title;
  const room_chl_start_title = messages[currentLocale].room_chl_start_title;
  const room_chl_end_title = messages[currentLocale].room_chl_end_title;
  const main_department_code = messages[currentLocale].main_department_code;
  const main_department_name = messages[currentLocale].main_department_name;
  const sub_department_name = messages[currentLocale].sub_department_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;

  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const firm_update_successfully = messages[currentLocale].firm_update_successfully;
  const dpr_update_successfully = messages[currentLocale].dpr_update_successfully;

  const firm_main_code = messages[currentLocale].firm_main_code;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;

  useEffect(() => {
    if (drcData && drcData.tbl_gnl_def) {
      const selectedRoomClass = drcData.tbl_gnl_def.find(item => item.code === rClassCode);
      if (selectedRoomClass) {
        setRClassName(selectedRoomClass.name);
      }
    }
  }, [rClassCode, drcData]);

  useEffect(() => {
    if (firmData) {
      setRClassName(firmData.r_class_name_n);
      setRClassCode(firmData.r_class_code_n);
      
    }
  }, [firmData]);

  const handleUpdate = () => {
    UpdateRoomClass({
      variables: {
        firmCode: firmData.firm_sub_code_n,
        rClassName: rClassName,
        rClassCode: rClassCode,
        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  };

  const handleinsert = () => {
    InsertRoomClass({
      variables: {
        firmCode: theme,
        firmMainCode: varCode2,
        rClassName: rClassName,
        rClassCode: rClassCode,
        
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        ownFirmSubType: ownFirmSubType,
    
           
      },
    })
      .then(() => {
        window.alert("Firm insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert firm:", error);
      });
  };

  if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error.message}</p>;

return (
  <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    

    <div className="flex">
  <div className="mr-2 w-full" >
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {room_class_code}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={rClassCode}
      onChange={(e) => setRClassCode(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
   />
  </div>

  <div>
  <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {room_class_name}
    </label>
  <Dropdown
  
    className="h-11 w-fit rounded-md"
    
    style={{ flex: '2' }}
    value={rClassCode}
    options={roomClassSelectItems}
    onChange={(e) => setRClassCode(e.value)}
    placeholder={select_a_room_class}
  />
  </div>


</div>

    <div className="mt-4">
      <label htmlFor="firmName" className="block font-medium text-gray-700">
       {room_class_name}
      </label>
      <input
        type="text"
        id="firmName"
        name="firmName"
        value={rClassName}
        onChange={(e) => setRClassName(e.target.value)}
        className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      />
    </div>

    

    <div className="mt-4 flex justify-end">
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdate}
      >
        {updaterec}
      </button>
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleinsert}
      >
        {create_room_classrec}
      </button>
    </div>
  </div>
);
};

export default FirmSubUpdate;
